import React, { Fragment } from 'react'

import Link from '@Pure/Link'

import { capitalize } from '@root/utility'

export var form =
{
	model  : 'user',
	name   : 'user',
	pattern: 'user',

	form_title: 'Utilisateur',

	fields:
	{
		firstname:
		{
			label: 'Prénom'
		},

		lastname:
		{
			label: 'Nom'
		},

		login:
		{
			label: 'E-mail',
			type: 'email'
		},

		'permissions[title]':
		{
			label: 'Type d\'utilisateur',
			type: 'select',
			options:
			[
				{
					value: 'Membre de synergies'
				},
				{
					value: 'Membre de CE'
				},
				{
					value: 'Administrateur de CE'
				},
				{
					value: 'Partenaire'
				},
				{
					label: 'Partenaire juridique',
					value: 'legal_writer'
				}
			]
		},

		EC:
		{
			label: 'Comité d\'Entreprise',
			reference:
			{
				model: 'EnterpriseCommittee'.toLowerCase(),
				referenced_field:
				{
					name: 'company',
					type: 'text'
				},
				autocomplete:
				{
					'company':
					{
						type: 'text'
					}
				}
			},
			show: function (form_data)
			{
				let show_when = ['Membre de CE', 'Administrateur de CE'];

				return show_when.indexOf(form_data['user[permissions][title]']) !== -1;
			}
		},

		user_function:
		{
			label: 'Fonction',
			reference:
			{
				model: 'UserFunction'.toLowerCase(),
				referenced_field:
				{
					name: 'label',
					type: 'text'
				},
				autocomplete:
				{
					'label':
					{
						type: 'text'
					}
				}
			},
			show: function (form_data)
			{
				let show_when = ['Partenaire'];

				return show_when.indexOf(form_data['user[permissions][title]']) === -1;
			}
		},

		password:
		{
			label: 'Mot de passe',
			type: 'password',
			show: data => ['Membre de synergies', 'legal_writer']
			.includes(data['user[permissions][title]'])
		},

		is_partner:
		{
			label: 'Partenaire',
			type: 'checkbox',
			show: data => data['user[permissions][title]'] !== 'Partenaire' &&
				!data['user[partners][0]']
		},

		partners:
		{
			label: 'Partenaires administrables',
			reference:
			{
				model: 'partner',
				referenced_field:
				{
					name: 'name',
					type: 'text'
				}
			},
			autocomplete: 'name',
			show: data => [true, 'true'].includes(data['user[is_partner]'])
		},

		comment:
		{
			label: 'Commentaire',
			type: 'textarea'
		},

		'permissions[ECs_managment]':
		{
			label: 'Gestion des CE',
			type: 'checkbox',
			show: data => data['user[permissions][title]'] === 'Membre de synergies'
		},

		'permissions[users_managment]':
		{
			label: 'Gestion des utilisateurs',
			type: 'checkbox',
			show: data => data['user[permissions][title]'] === 'Membre de synergies'
		},

		'permissions[catalog_managment]':
		{
			label: 'Gestion du catalogue produit',
			type: 'checkbox',
			show: data => data['user[permissions][title]'] === 'Membre de synergies'
		},

		'permissions[partners_managment]':
		{
			label: 'Gestion des partenaires',
			type: 'checkbox',
			show: data => data['user[permissions][title]'] === 'Membre de synergies'
		},

		'permissions[orders_managment]':
		{
			label: 'Gestion des commandes',
			type: 'checkbox',
			show: data => data['user[permissions][title]'] === 'Membre de synergies'
		}
	},

	collapses:
	[
		{
			title: 'Comité d\'Entreprise',
			open: true,
			elements:
			[
				'permissions[title]',
				'EC'
			]
		},

		{
			title: 'Comité d\'Entreprise',
			open: true,
			grid_class: 'o-grid-5',
			show: data => data['user[permissions][title]'] === 'Membre de synergies',

			elements:
			[
				'permissions[ECs_managment]',
				'permissions[users_managment]',
				'permissions[catalog_managment]',
				'permissions[partners_managment]',
				'permissions[orders_managment]'
			]
		}
	],

	views:
	[
		{
			title: 'Partenaires administrables',
			search_label: 'Chercher un partenaire',
			source_field: 'partners',
			add_label: 'Ajouter ce partenaire',
			grid_class: 'o-grid-4',

			show: data => [true, 'true'].includes(data['user[is_partner]']) ||
				data['user[permissions][title]'] === 'Partenaire' ||
				data['user[partners][0]'],

			render: function (data, key)
			{
				let address_1 = data.model_data.address_1 || undefined;
				let address_2 = data.model_data.address_2 || undefined;

				if (address_2)
				{
					address_2 =
					<Fragment>
						<br />
						{ data.model_data.address_2 }
					</Fragment>
				}

				let zip_code = data.model_data.zip_code || undefined;
				let city = data.model_data.city || undefined;
				let address;

				if (zip_code || city)
				{
					if (zip_code)
					{
						if (city)
						{
							zip_code =
							(
								<Fragment>
									<br />
									{ zip_code + ' ' }
								</Fragment>
							);
						}
					}

					address =
					(
						<Fragment>
							{ zip_code }
							{ city }
						</Fragment>
					);
				}

				let output =
				(
					<div className="o-grid__item" key={ key }>

						<div className="c-view-item">
							<svg className="o-svg-icon o-svg-icon--partner c-view-item__icon">
								<use xlinkHref="/images/icons.svg#svg-icon-partner"></use>
							</svg>

							<div className="c-view-item__infos">
								<div className="c-view-item__data">
									<span style={ { fontWeight: '600' } }>
										{ data.model_data.name }
									</span>
									<br />
									{ address_1 }
									{ address_2 }
									{ address }
								</div>
							</div>

							<Link className="u-link-only" target="_blank"
								href={ '/partenaires/' +
								data.model_data.id }></Link>
						</div>

					</div>
				);

				return output;
			},
			search:
			{
				display_fields: ['name', 'city']
			}
		}
	],

	create_label: 'Créer cet utilisateur',

	get__deleteModalText: function (form_data)
	{
		var output =
		(
			<span>
				<p>
					Êtes vous sûr de vouloir supprimer cet utilisateur&nbsp;?
				</p>

				<div className="u-center">

					<div className="name-in-modal">

						{ form_data['user[firstname]'] + ' ' + form_data['user[lastname]'] }

					</div>

				</div>
			</span>
		);

		return output;
	},

	get__createdMessage: function (model)
	{
		var output =
		(
			<div className="c-message c-message--green">
				<div className="c-message__content">
					Le nouvel utilisateur <strong> { model.firstname + ' ' + model.lastname } </strong> a été créé.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ '/gestion-des-CE/membres/' + model.id }>
						Voir la page de l'utilisateur
					</Link>
				</div>
			</div>
		);

		return output;
	}
};

export default form